import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn:'root'
})
export class AppUtilsService {

  private isTeamView: BehaviorSubject<boolean>;
  private isLoadSpinner: BehaviorSubject<boolean>;

  constructor() { 
    this.isTeamView = new BehaviorSubject<boolean>(false);
    this.isLoadSpinner = new BehaviorSubject<boolean>(false);
  }

  public setIsTeamView(newValue : boolean){
    this.isTeamView.next(newValue);
  }

  public setIsLoadSpinner(newValue : boolean){
    this.isLoadSpinner.next(newValue);
  } 

  public getIsTeamView(): Observable<boolean> {
    return this.isTeamView.asObservable();
  }

  public getIsLoadSpinner(): Observable<boolean> {
    return this.isLoadSpinner.asObservable();
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

}
